/**
 * @generated SignedSource<<87d71dbf54249e4b4b7239c7e2314832>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateSavedFilterInput = {
  name: string;
  criteria: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type savedFiltersCreateMutation$variables = {
  input: CreateSavedFilterInput;
};
export type savedFiltersCreateMutation$data = {
  readonly createSavedFilter: {
    readonly clientMutationId: string | null;
    readonly savedFilter: {
      readonly id: string;
      readonly name: string;
      readonly criteria: string | null;
    } | null;
  } | null;
};
export type savedFiltersCreateMutation = {
  variables: savedFiltersCreateMutation$variables;
  response: savedFiltersCreateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateSavedFilterPayload",
    "kind": "LinkedField",
    "name": "createSavedFilter",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SavedFilter",
        "kind": "LinkedField",
        "name": "savedFilter",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "criteria",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "savedFiltersCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "savedFiltersCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5b8aecb0231644349c23572bc39895c7",
    "id": null,
    "metadata": {},
    "name": "savedFiltersCreateMutation",
    "operationKind": "mutation",
    "text": "mutation savedFiltersCreateMutation(\n  $input: CreateSavedFilterInput!\n) {\n  createSavedFilter(input: $input) {\n    clientMutationId\n    savedFilter {\n      id\n      name\n      criteria\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e2ef90d03edf8d1a9e06c3799cfa1caf";

export default node;
